import { useDashboard } from './Provider'

import Box from '@mui/material/Box'

export default function Content({children}) {
    const {
        open,
        isMobile
    } = useDashboard()

    return (
        <>
            <Box sx={{
                height: '100vh',
                width: (open && !isMobile) ? 'calc(100% - 250px)' : '100%',
                marginInlineStart: (open && !isMobile) ? '250px' : '0',
                display: 'flex',
                flexDirection: 'column',
                transition: (theme) => theme.transitions.create(['width', 'margin'], {
                    easing: theme.transitions.easing.easeInOut,
                    duration: theme.transitions.duration.leavingScreen
                })
            }}>
                {children}
            </Box>
        </>
    )
}
